var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Machining Products",
      "tabActive": "CMP Retainer - Ring",
      "bg": "/images/sub/visual/sv2.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" CMP Retainer - Ring ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/products/cmp/cmp-top-img.png",
      "className": "h-lg-660px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-4 mb-lg-16"
  }, [_vm._v(" CMP ")]), _c('p', {
    staticClass: "page-text-lg color-point font-weight-semibold mb-8 mb-md-50 mb-lg-84"
  }, [_vm._v(" Chemical Mechanical Polishing ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-24 mb-lg-50"
  }, [_vm._v(" 반도체 제조 8대 공정 중 하나로, Wafer를 화학적 반응(Chemical)과 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 기계적 힘(Mechanical)을 이용하여 평탄하게 연마(Polishing)하는 반도체 공정 ")]), _c('p', {
    staticClass: "color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v(" Retainer Ring의 역할 ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51 mb-12 mb-lg-24"
  }, [_vm._v(" CMP 장비 HEAD에 장착되어 CMP공정 중 Wafer의 이탈을 방지하기 위한 가이드 역할 및 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Wafer의 Uniformity를 Support 하는 역할 ")]), _c('p', {
    staticClass: "color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v(" Retainer Ring Type ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("Two-Body Type")]), _vm._v(" "), _c('br'), _vm._v(" (Metal + Engineering Plastic bonding 타입) "), _c('br'), _vm._v(" IST 기술로 Metal (SUS 304 or 316) 과 Engineering Plastic (PPS, PEEK, 기타 등 등)을 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 결합하여 Bonding Type으로 제작한 타입 Retainer Ring ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("One-Body Type ")]), _vm._v(" "), _c('br'), _vm._v(" (Engineering Plastic 소재만 가능 – PPS, PEEK and 기타 등 등) "), _c('br'), _vm._v(" 단일 소재로 Engineering Plastic (PPS, PEEK and ect..) 을 제작한 Retainer Ring ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("Insert Over Molding Type")]), _vm._v(" "), _c('br'), _vm._v(" (Insert + PEEK 사출 몰딩) Insert를 삽입하여 사출하는 방식의 Retainer Ring ")])])], 1), _vm.boards ? _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('slide-primary', _vm._l(_vm.boards, function (board) {
    return _c('div', {
      key: board._id,
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "pb-16 pb-lg-30 border-bottom"
    }, [_c('div', {
      staticClass: "thum-wrap"
    }, [_c('div', {
      staticClass: "thum",
      style: "background-image: url(".concat(board.thumb, ")")
    })])])]);
  }), 0)], 1)], 1) : _vm._e(), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-img1.png",
      "name": "이 광호",
      "tel": "031-765-2268",
      "mail": "khlee@ist-co.kr",
      "fax": "031-765-2389"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }